import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class EventStatusService {

  constructor(private http: HttpClient) { }

  async getStatus() {
    try {
      let response = await this.http
        .get(`${appApiResources.getEventStatus}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async downloadStateWiseReport(id) {
    try {
      let response = await this.http
        .get(`https://officetest.ezekiahfrancis.org/statewisereport?event_id=${id}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async downloadCountryWiseReport(id) {
    try {
      let response = await this.http
        .get(`https://officetest.ezekiahfrancis.org/countrywisereport?event_id=${id}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async downloadPaidReport(query) {
    try {
      let filter = `partner_id=${query.partner_id}&full_name=${query.full_name}&phone_number=${query.phone_number}&email_id=${query.email_id}&address_line1=${query.address_line1}&address_line2=${query.address_line2}&address_line3=${query.address_line3}&city=${query.city}&district=${query.district}&state_id=${query.state}&country_id=${query.country}&pincode=${query.pincode}&occupation=${query.occupation}&education_id=${query.education}&language_id=${query.language_id}&role_id=${query.role_id}&event_id=${query.event_id}&from_date=${query.from_date}&end_date=${query.end_date}&paid=1`
      let response = await this.http
        .get(`https://officetest.ezekiahfrancis.org/eventsreglist?${filter}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async downloadUnPaidReport(query) {
    try {
      let filter = `partner_id=${query.partner_id}&full_name=${query.full_name}&phone_number=${query.phone_number}&email_id=${query.email_id}&address_line1=${query.address_line1}&address_line2=${query.address_line2}&address_line3=${query.address_line3}&city=${query.city}&district=${query.district}&state_id=${query.state}&country_id=${query.country}&pincode=${query.pincode}&occupation=${query.occupation}&education_id=${query.education}&language_id=${query.language_id}&role_id=${query.role_id}&event_id=${query.event_id}&from_date=${query.from_date}&end_date=${query.end_date}&unpaid=1`
      let response = await this.http
        .get(`https://officetest.ezekiahfrancis.org/eventsreglist?${filter}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

}
